@if (stories().length > 0) {
  <section class="surface-primary elevation-level-1 rounded-large ps-large" data-testid="cms-ond-bluewings">
    @if (title()) {
      <h2
        class="nordic-blue-900-text text-icon-primary font-headline-small mr-clear-t mr-large-b"
        data-testid="cms-ond-bluewings-title"
      >
        {{ title() }}
      </h2>
    }

    <div class="grid-col-12 no-gutters">
      @for (story of stories(); track story.contentId) {
        <fin-teaser-card
          class="col-1-12 card-wrapper"
          data-testid="cms-ond-bluewings-story"
          [aspectRatio]="'16x9'"
          [content]="story"
          [attr.lang]="story.contentLocale"
        />
      }
    </div>
  </section>
}
